module.exports = __webpack_public_path__ + "static/media/微电影.9517c8c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/微电影.mp4
// module id = m+am
// module chunks = 3